function scrollTo(element, to, duration) {
    let start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    let animateScroll = function() {
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

window.initOfficeLocator = function() {
    // Define default center position //
    // Center on Australia //
    // let centerLat = -33.865143;
    // let centerLng =  151.209900;

    // Center on Eastern seaboard //
    let centerLat = -31.2532;
    let centerLng = 151.209900;

    // Define Map //
    const map = document.getElementById("map");
    let googleMap;

    // Define Map Options //
    let mapOptions = {
        zoom: 5,
        streetViewControl: false,
        mapTypeControl: false,
        scrollWheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    // Define Markers, Filters and Serch vars //
    let userMarker;
    let markers = [];
    const offices = Array.from(document.querySelectorAll('.js-office'));
    let markerIcon;
    let markerLabel;
    let filters = [];
    let placeSearched = false;
    let noResults = false;

    let markerIconDefault = {
        path: 'M12,24a1.16,1.16,0,0,0,.51-.12,1.07,1.07,0,0,0,.41-.32C13.75,22.56,21,13.61,21,9A9,9,0,0,0,3,9c0,4.61,7.25,13.56,8.07,14.56a1,1,0,0,0,.42.32A1.13,1.13,0,0,0,12,24Z',
        scale: 1.5,
        fillColor: '#ffffff',
        fillOpacity: 1,
        strokeColor: '#002D67',
        strokeWeight: 2,
        labelOrigin: new google.maps.Point(12, 10),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 24)
    };

    let markerIconActive = {
        path: 'M12,24a1.16,1.16,0,0,0,.51-.12,1.07,1.07,0,0,0,.41-.32C13.75,22.56,21,13.61,21,9A9,9,0,0,0,3,9c0,4.61,7.25,13.56,8.07,14.56a1,1,0,0,0,.42.32A1.13,1.13,0,0,0,12,24Z',
        scale: 1.5,
        fillColor: '#002D67',
        fillOpacity: 1,
        strokeColor: '#002D67',
        strokeWeight: 2,
        labelOrigin: new google.maps.Point(12, 10),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 24)
    };


    // Define InfoWindow Vars //
    let infoWindow;
    let infoWindowObject;

    offices.forEach(function(office, index) {
        markers.push({
            id: index,
            office: office,
            marker: null,
            filtered: false
        })
    });

    // Define Results List for Scroll To //
    const resultsList = Array.from(document.querySelectorAll(".office__locator__results"))[0];

    function mapRecenter(map, latlng, offsetx, offsety) {
        const point1 = map.getProjection().fromLatLngToPoint(
            (latlng instanceof google.maps.LatLng) ? latlng : map.getCenter(),
        );
        const point2 = new google.maps.Point(
            ((typeof(offsetx) === 'number' ? offsetx : 0) / Math.pow(2, map.getZoom())) || 0,
            ((typeof(offsety) === 'number' ? offsety : 0) / Math.pow(2, map.getZoom())) || 0,
        );
        map.setCenter(map.getProjection().fromPointToLatLng(new google.maps.Point(
            point1.x - point2.x,
            point1.y + point2.y,
        )));
    }

    // Check local storage for feature office search
    function checkLocalStorage() {
        if (localStorage.getItem("officeFeatureSearch")) {
            const searchedPlace = localStorage.getItem("officeFeatureSearch");
            centerLat = JSON.parse(searchedPlace).centerLat;
            centerLng = JSON.parse(searchedPlace).centerLng;
            localStorage.removeItem("officeFeatureSearch");
            const yOffset = -(document.querySelector('.header__container--sticky').offsetHeight);
            const y = document.getElementById('map__container').getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            setUserMarker(centerLat, centerLng);
        }
    }

    function bindMarkers() {
        markers.forEach((marker) => {
            // Bind marker click event
            marker.office.addEventListener('click', function() {
                let office = this;
                let activeMarker = markers.find((marker) => marker.office === office);

                // Add map infoWindow
                if ('undefined' !== typeof infoWindowObject) {
                    infoWindow = infoWindowObject;
                } else {
                    infoWindow = new google.maps.InfoWindow({
                        disableAutoPan: true
                    });

                    infoWindowObject = infoWindow;
                }

                markers.forEach((marker) => {
                    if (marker.id !== activeMarker.id) {
                        if (marker.marker) {
                            marker.marker.setIcon(markerIcon);
                            let markerLabel = marker.marker.getLabel();
                            markerLabel.color = "#002D67";
                            marker.marker.setLabel(markerLabel);

                            if (marker.office.classList.contains('active')) {
                                marker.office.classList.remove('active');
                            }
                        }
                    }
                });

                // Set new active marker
                office.classList.add('active');
                activeMarker.marker.setIcon(markerIconActive);
                let activeMarkerLabel = activeMarker.marker.getLabel();
                activeMarkerLabel.color = "#FFFFFF";
                activeMarker.marker.setLabel(activeMarkerLabel);



                if ('undefined' !== typeof office.dataset.infoWindow && office.dataset.infoWindow) {
                    // Close open infoWindows
                    infoWindow.close();

                    //Set new infoWindow content
                    infoWindow.setContent(office.dataset.infoWindow);

                    // Open new infoWindow
                    infoWindow.open(googleMap, activeMarker.marker);
                }

                setTimeout(function() {
                    // Update map center point
                    mapRecenter(googleMap, activeMarker.marker.getPosition(), 0, -0.05);

                    // Update map zoom level
                    googleMap.setZoom(15);
                }, 50);
            })
        })
    }

    function clearMarkers() {
        markers.forEach(marker => {
            if (marker.marker) {
                marker.marker.setMap(null);
                marker.marker = null;
                marker.office.style.display = "none";
            }
        })
    }

    function refreshMapPosition() {
        if (noResults){
            googleMap.setCenter({ lat: -31.2532, lng: 151.209900 });
        } else if (markers.length > 0) {
            if (1 === markers.length) {
                markers.forEach(function(marker) {
                    if (marker.marker) {
                        googleMap.setZoom(15);
                        googleMap.setCenter(marker.marker.getPosition());
                    }
                });
            } else {
                // Set bounding area of multiple markers
                const bounds = new google.maps.LatLngBounds();
                if (userMarker) {
                    bounds.extend(userMarker.getPosition());
                }
                markers.forEach((marker) => {
                    if (marker.marker) {
                        bounds.extend(marker.marker.getPosition());
                    }
                });

                googleMap.fitBounds(bounds);
            }
        }
    }

    function refreshMapMarkers() {
        let count = 0;
        for (let marker of markers) {
            if (!marker.filtered) {
                // Update marker count //
                count = count + 1;

                // Define office and update count //
                let office = marker.office;
                office.querySelector('.js-office-count').innerText = count;

                // Define map marker //
                let mapMarker;

                // Check if marker is already initialized nad update position
                if ('undefined' !== typeof marker.marker) {
                    mapMarker = marker.marker;
                }

                // Get Marker Lat/Lng //
                let lat = 'undefined' === typeof office.dataset.latitude ? '' : office.dataset.latitude.toString();
                let lng = 'undefined' === typeof office.dataset.longitude ? '' : office.dataset.longitude.toString();

                if (lat.length > 0 && lng.length > 0) {
                    if (mapMarker) {
                        mapMarker.setPosition(new google.maps.LatLng(lat, lng));
                    } else {
                        // Set Marker icon style
                        if (office.classList.contains('active')) {
                            // Set active marker style
                            markerIcon = markerIconActive;
                            markerLabel = {
                                text: String(count),
                                color: '#FFFFFF',
                                fontWeight: 'bold',
                                fontSize: '14px',
                            };

                        } else {
                            // Set default marker style
                            markerIcon = markerIconDefault;
                            markerLabel = {
                                text: String(count),
                                color: '#002D67',
                                fontWeight: 'bold',
                                fontSize: '14px'
                            };
                        }

                        mapMarker = new google.maps.Marker({
                            position: new google.maps.LatLng(lat, lng),
                            icon: markerIcon,
                            label: markerLabel,
                            map: googleMap,
                        });

                        google.maps.event.addListener(mapMarker, 'click', function() {
                            // Handle animate to active marker
                            scrollTo(resultsList, office.offsetTop - 24, 600);

                            // Set active card, marker and trigger infoWindow
                            office.click();

                            // Center map on marker
                            refreshMapPosition();
                        });
                    }

                    // Add maker object to item in markers array
                    marker.marker = mapMarker;

                    // Set active office
                    office.style.display = "block";
                    office.classList.add('active-marker');
                }

                if (placeSearched) {
                    if (count >= 8) {
                        break;
                    }
                }
            }
        }
    }

    function setUserMarker(lat, lng) {
        calculateDistances();

        // Set user marker
        if (userMarker !== undefined) {
            userMarker.setPosition({
                lat,
                lng
            });
        } else {
            userMarker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: googleMap,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 0,
                    strokeWeight: 0,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                },
            });
        }

        // Ensure user marker and closest office marker are shown
        // and set first office card and marker to be active
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(userMarker.getPosition());
        markers.forEach((marker, index) => {
            marker.office.classList.remove('active');
            if (marker.marker && !marker.filtered) {
                if (index === 0) {
                    marker.office.classList.add('active');
                }
                bounds.extend(marker.marker.getPosition());
            }
        });

        googleMap.fitBounds(bounds);
        googleMap.setZoom(5);
        googleMap.setCenter(userMarker.getPosition());

        clearMarkers();
        refreshMapMarkers();
        refreshMapPosition();
    }

    const officesListContainer = document.querySelector('.office__locator__results');

    function calculateDistances() {
        offices.forEach((office) => {
            // Calculate distance between user and office
            const distance = google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(centerLat, centerLng),
                new google.maps.LatLng(office.getAttribute('data-latitude'), office.getAttribute('data-longitude')),
            );
            office.setAttribute('data-distance', Math.round((distance / 1000) * 10) / 10);
            const kms = `${Math.round((distance / 1000) * 10) / 10}km from searched address`;
            office.querySelector('.js-card__distance').innerText = kms;
        });

        // Re-order offices in results list and map markers based on distance to user
        offices.sort((a, b) => a.dataset.distance - b.dataset.distance);
        offices.forEach((office) => {
            officesListContainer.querySelector('.cards__list--office').appendChild(office);
        });
        markers.sort((a, b) => a.office.dataset.distance - b.office.dataset.distance);

        markers.forEach((marker, index) => {
            if(index === 0 && marker.office.dataset.distance > 81) {
                marker.filtered = true;
                noResults = true;
                document.getElementById('offices-no-results-message').style.display = 'block';
            } else if (marker.office.dataset.distance > 81) {
                marker.filtered = true;
            }
        });
    }

    function inititalizeGoogleMap() {
        let initialMapOptions = mapOptions;

        initialMapOptions['center'] = new google.maps.LatLng(centerLat, centerLng);

        googleMap = new google.maps.Map(map, initialMapOptions);

        refreshMapMarkers();
        // refreshMapPosition();
    }

    function bindFilters() {
        const filterItems = Array.from(document.querySelectorAll('.js-find-an-office-filter'));
        filterItems.forEach((item) => {
            item.addEventListener('click', () => {
                console.log(item);
                const input = item.querySelector('.form__input--checkboxes');
                console.log(input);
                const inputValue = input.value;
                setTimeout(function() {
                    if (input.checked) {
                        filters.push(inputValue)
                    } else {
                        filters.splice(filters.indexOf(inputValue), 1);
                    }

                    filterOffices(filters);
                }, 50)
            })
        })
    }

    function filterOffices(filters) {
        if (filters.length > 0) {
            markers.forEach((marker) => {
                // check if office has program
                const programs = marker.office.dataset.programs;
                const programsArray = programs.split(', ');
                const hasProgram = filters.some(i => programsArray.includes(i));

                // check if office is in state
                const state = marker.office.dataset.state;
                const isInState = filters.includes(state);

                if (hasProgram || isInState) {
                    marker.filtered = false;
                } else {
                    marker.filtered = true;
                }
            });
        } else {
            markers.forEach((marker) => {
                marker.filtered = false;
            });
        }

        clearMarkers();
        refreshMapMarkers();
        refreshMapPosition();
    }

    function bindAutocompleteSearch() {
        // Define Autocomplete
        const autoCompleteInput = document.getElementById("find-an-office-search");
        const autoCompleteOptions = {
            types: ['(regions)'],
            componentRestrictions: {
                country: 'au',
            },
        };

        const autoComplete = new google.maps.places.Autocomplete(autoCompleteInput, autoCompleteOptions);
        autoComplete.addListener('place_changed', () => {
            placeSearched = true;
            const place = autoComplete.getPlace();

            if (!place.geometry) {
                return;
            }

            centerLat = place.geometry.location.lat();
            centerLng = place.geometry.location.lng();

            setUserMarker(centerLat, centerLng);
        });
    }

    inititalizeGoogleMap();
    bindAutocompleteSearch();
    bindMarkers();
    bindFilters();
    checkLocalStorage();
}



window.initOfficeAutoComplete = function() {
    function bindAutocompleteSearch() {
        // Define Autocomplete
        const autoCompleteInput = document.getElementById("find-an-office-search--feature");
        const autoCompleteOptions = {
            types: ['(regions)'],
            componentRestrictions: {
                country: 'au',
            },
        };

        const autoComplete = new google.maps.places.Autocomplete(autoCompleteInput, autoCompleteOptions);
        autoComplete.addListener('place_changed', () => {
            placeSearched = true;
            const place = autoComplete.getPlace();

            if (!place.geometry) {
                return;
            }

            const searchedPlace = {
                centerLat: place.geometry.location.lat(),
                centerLng: place.geometry.location.lng()
            }

            localStorage.setItem('officeFeatureSearch', JSON.stringify(searchedPlace));
            window.location.href = `${window.location.href}find-your-nearest-office`;
        });
    }

    bindAutocompleteSearch();
}


// WEBPACK FOOTER //
// ../project/craft/src/components/office-locator/office-locator.js